(function () {
  const ROOT_SELECTOR = '[data-related-collections-scroll]';
  const DRAG_THRESHOLD_PX = 5;

  /**
   * @param {HTMLElement} container
   */
  function bindContainer(container) {
    if (container.dataset.scrollBound === 'true') {
      return;
    }
    container.dataset.scrollBound = 'true';

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let didDrag = false;
    let activePointerId = null;

    container.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    container.querySelectorAll('img').forEach(function (image) {
      image.setAttribute('draggable', 'false');
    });

    container.addEventListener('pointerdown', function (event) {
      if (event.button !== 0 || event.pointerType !== 'mouse') {
        return;
      }

      isDragging = true;
      didDrag = false;
      startX = event.clientX;
      scrollLeft = container.scrollLeft;
      activePointerId = event.pointerId;
    });

    container.addEventListener('pointermove', function (event) {
      if (!isDragging || event.pointerId !== activePointerId) {
        return;
      }

      const deltaX = event.clientX - startX;
      if (!didDrag && Math.abs(deltaX) >= DRAG_THRESHOLD_PX) {
        didDrag = true;
        container.classList.add('is-dragging');
        container.setPointerCapture(event.pointerId);
      }

      if (didDrag) {
        event.preventDefault();
        container.scrollLeft = scrollLeft - deltaX;
      }
    });

    function endDrag(event) {
      if (!isDragging) {
        return;
      }

      isDragging = false;
      container.classList.remove('is-dragging');

      if (event && activePointerId !== null && container.hasPointerCapture(activePointerId)) {
        container.releasePointerCapture(activePointerId);
      }

      activePointerId = null;
    }

    container.addEventListener('pointerup', endDrag);
    container.addEventListener('pointercancel', endDrag);
    container.addEventListener('lostpointercapture', endDrag);

    container.addEventListener(
      'click',
      function (event) {
        if (!didDrag) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      },
      true
    );
  }

  /**
   * @param {ParentNode} [scope]
   */
  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(bindContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
